export default __webpack_public_path__ + "static/media/Multiplatform.b17c9d60.png";